<template >
  <div class="new-home-service-section new-home-service-section--cookbook">
    <img
      srcset="
        /images/fr_new_home/hero/service_hero_m.png 768w,
        /images/fr_new_home/hero/service_hero.png
      "
      src="/images/fr_new_home/hero/service_hero.png"
      class="service-hero"
    />
    <NewHomePacks :box="box" />
    <NewHomeService />
  </div>
</template>
<script>
import NewHomePacks from "./NewHomePacks.vue";
import NewHomeService from "./NewHomeService.vue";

export default {
    props: {
        box: {
            type: String,
            default: 'list'
        },
    },
  components: {
    NewHomePacks,
    NewHomeService,
  },
};
</script>
